/**
 * Labstep
 *
 * @module components/File/Filter/Extension/Active
 * @desc Active filter component for extension active
 */

import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { FileFilterExtensionActiveProps } from './types';

export const FileFilterExtensionActive: React.FC<
  FileFilterExtensionActiveProps
> = ({ clearParams, searchParams }) =>
  'extension' in searchParams ? (
    <RemoveLabel
      name={searchParams.extension as string}
      onRemoveClick={
        clearParams && (() => clearParams(['extension']))
      }
    />
  ) : null;
